/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_WaitingInputs */

const cs_pm_waiting = /** @type {(inputs: Pm_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeká na spuštění`)
};

const en_pm_waiting = /** @type {(inputs: Pm_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting to start`)
};

/**
* | output |
* | --- |
* | "Waiting to start" |
*
* @param {Pm_WaitingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_waiting = /** @type {((inputs?: Pm_WaitingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_WaitingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_waiting(inputs)
	return cs_pm_waiting(inputs)
});